import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { AuthenticationService } from '@app/services/authentication.service';
import { Facility, Field, FieldCapacity } from '@app/_models/facilities';
import { User } from '@app/_models/user';
import { FacilityService } from './facilities.service';


@Injectable( { providedIn: 'root' })
export class SessionService {
  private p_user: User;
  private p_canchas: Field[];
  private p_facility: Facility;
  private p_sizes: FieldCapacity[];
    
  private session_initialized: BehaviorSubject<boolean>;
  public sessionInitialized: Observable<any>;

  error = '';

  constructor(
    private authenticationService: AuthenticationService,
    private facilityService: FacilityService
  ) {
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
      this.session_initialized = new BehaviorSubject<boolean>(false);
      this.sessionInitialized = this.session_initialized.asObservable();
    }

    public get currentUser(): User {
        return JSON.parse(sessionStorage.getItem('currentUser'));
    }

    public set currentUser(user: User) {
        this.p_user = user;
    }

    public set currentFacility(data: Facility) {
        this.p_facility = data;
        sessionStorage.setItem('currentFacility', JSON.stringify(this.p_facility));
        this.canchas = this.p_facility.fields;
        var v_sizes = [];
        
        for (let cancha of this.p_canchas) {
            let s = cancha.capacities
            for (let c of s) {
                const fc: FieldCapacity = new FieldCapacity();
                var n = parseInt(c.description) / 2;
                fc.id = c.id;
                fc.description = c.description;
                fc.display_description = `${n} vs ${n}`;
                let found = v_sizes.some(elem => elem.id == c.id);
                if (!found) {
                    v_sizes.push(fc);
                }
            }
        }
        this.p_sizes = v_sizes.sort((a,b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
    }

    public get currentFacility(): Facility {
        return JSON.parse(sessionStorage.getItem('currentFacility'));
    }

    public set canchas(data) {
        this.p_canchas = data;
        sessionStorage.setItem('currentCanchas', JSON.stringify(this.p_canchas));
    }

    public get canchas() {
        return JSON.parse(sessionStorage.getItem('currentCanchas'));
    }

    public get field_sizes() {
        const sizesFilter = this.p_sizes.filter(size => size.id === 3 || size.id === 5);
        return sizesFilter;
    }

    public set initialized(value) {
        this.session_initialized.next(value);
    }

    public initSession(facility_id) {
        this.facilityService.getFacility(facility_id).subscribe(
            (data: Facility) => {
                this.currentFacility = data;
                this.initialized = true;
                this.session_initialized.next(true);
            },
            error => {
                this.error = error;
                this.session_initialized.next(false);
            },
        );
    }

    public closeSession() {
        console.log('Closing session....');
        sessionStorage.clear();
        this.initialized = false;
    }

    public accessType(perm) {
        // Verifica si tiene Full Access primero
        const v_full = this.currentUser.perms.find(({ permission }) => permission === "full");
        if (v_full) {
            return "2";
        }

        var response = "-1"
        const v_perm = this.currentUser.perms.find(({ permission }) => permission === perm);
        if (v_perm) {
            response = v_perm.access_type;
        }
        return response
    }
}
